import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { CONTACT } from "@/data/content";

const SECTIONS = [
  {
    title: "Vilka uppgifter vi samlar in",
    body: [
      "När du använder kontaktformuläret på webbplatsen samlar vi in de uppgifter du själv lämnar: namn, organisation, e-postadress, eventuellt telefonnummer samt innehållet i ditt meddelande.",
    ],
  },
  {
    title: "Varför vi behandlar uppgifterna",
    body: [
      "Uppgifterna behandlas för att vi ska kunna ta emot, förstå och besvara din förfrågan samt föra en fortsatt dialog om det du kontaktar oss kring.",
    ],
  },
  {
    title: "Hur uppgifterna används",
    body: [
      "Informationen används endast för att hantera din kontakt med IC Identity. Vi säljer eller lämnar aldrig ut dina uppgifter till tredje part för marknadsföringsändamål.",
      "Uppgifterna sparas endast så länge det behövs för att hantera din förfrågan och den efterföljande dialogen.",
    ],
  },
  {
    title: "Dina rättigheter",
    body: [
      "Du har rätt att begära tillgång till de uppgifter vi behandlar om dig, samt att begära rättelse eller radering. Kontakta oss om du vill utöva någon av dessa rättigheter.",
    ],
  },
  {
    title: "Kontakt i personuppgiftsfrågor",
    body: [
      "Har du frågor om hur IC Identity behandlar dina personuppgifter är du välkommen att kontakta oss.",
    ],
  },
];

export default function Privacy() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Integritetspolicy | IC Identity";
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <>
      <Header />
      <main className="bg-white">
        <div className="mx-auto max-w-3xl px-6 pb-24 pt-36 md:pt-44 lg:px-8">
          <div className="mb-12">
            <Link to="/" className="btn-line" data-testid="privacy-back">
              <ArrowLeft className="h-4 w-4" />
              Till startsidan
            </Link>
          </div>

          <p className="eyebrow">
            <span className="ic-triangle" aria-hidden="true" />
            Integritetspolicy
          </p>
          <h1 className="mt-7 font-display text-4xl font-normal leading-[1.1] tracking-[-0.01em] text-brand-ink md:text-5xl">
            Så hanterar vi dina uppgifter
          </h1>
          <p className="mt-6 text-lg leading-relaxed text-brand-muted">
            IC Identity värnar om din integritet. Här beskriver vi kortfattat vilka uppgifter som
            samlas in via webbplatsens kontaktformulär och hur de behandlas.
          </p>

          <div className="mt-14 space-y-12">
            {SECTIONS.map((section) => (
              <section key={section.title}>
                <h2 className="font-display text-2xl text-brand-ink">{section.title}</h2>
                <div className="mt-4 space-y-4">
                  {section.body.map((para, i) => (
                    <p key={i} className="leading-relaxed text-brand-muted">
                      {para}
                    </p>
                  ))}
                  {section.title === "Kontakt i personuppgiftsfrågor" && (
                    <p className="leading-relaxed text-brand-ink">
                      <a href={CONTACT.emailHref} className="transition-colors hover:text-brand-blue">
                        {CONTACT.email}
                      </a>
                      <br />
                      <a href={CONTACT.phoneHref} className="transition-colors hover:text-brand-blue">
                        {CONTACT.phone}
                      </a>
                    </p>
                  )}
                </div>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
